import React from 'react';
import PublicLayout from '../components/PublicLayout';
import { Check, Mail } from 'lucide-react';

const Pricing = () => {
  return (
    <PublicLayout theme="dark">
      <div className="public-page">
        {/* Hero Section */}
        <div className="public-page-header">
          <h1>Choose Your Path to Success</h1>
          <p>
            Join an elite network of entrepreneurs and leaders. Select the membership that fits your goals.
          </p>
        </div>

        <div className="public-page-content">
          {/* Member Pricing */}
          <div className="mb-16">
            <h2 className="text-center">Member Pricing</h2>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-6xl mx-auto mt-8">
              {/* Student */}
              <div className="dashboard-card">
                <div className="text-center mb-6">
                  <h3 className="text-2xl font-bold mb-2" style={{fontFamily: 'var(--font-heading)'}}>Student</h3>
                  <div className="text-4xl font-bold mb-2" style={{color: 'var(--gold)'}}>$10</div>
                  <p style={{color: 'var(--muted)'}}>per month</p>
                </div>
                <ul className="space-y-3 mb-8">
                  <li className="flex items-start gap-2">
                    <Check className="w-5 h-5 flex-shrink-0" style={{color: '#10b981'}} />
                    <span>Access to all events</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <Check className="w-5 h-5 flex-shrink-0" style={{color: '#10b981'}} />
                    <span>Digital magazine subscription</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <Check className="w-5 h-5 flex-shrink-0" style={{color: '#10b981'}} />
                    <span>Community challenges</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <Check className="w-5 h-5 flex-shrink-0" style={{color: '#10b981'}} />
                    <span>Points & leaderboard</span>
                  </li>
                </ul>
                <a href="/auth" className="btn-primary block text-center no-underline">
                  Get Started
                </a>
              </div>

              {/* General */}
              <div className="dashboard-card" style={{background: 'linear-gradient(135deg, #D4AF37 0%, #C29A4B 100%)', color: '#fff', transform: 'scale(1.05)', boxShadow: '0 20px 40px rgba(212, 175, 55, 0.3)', position: 'relative'}}>
                <div className="text-center mb-6">
                  <div className="inline-block text-xs font-bold px-4 py-1.5 mb-3" style={{background: '#000', color: '#D4AF37', borderRadius: '4px', letterSpacing: '0.1em', border: '1px solid #D4AF37'}}>MOST POPULAR</div>
                  <h3 className="text-2xl font-bold mb-2" style={{fontFamily: 'var(--font-heading)', color: '#fff'}}>General</h3>
                  <div className="text-4xl font-bold mb-2">$15</div>
                  <p style={{color: 'rgba(255,255,255,0.9)'}}>per month</p>
                </div>
                <ul className="space-y-3 mb-8">
                  <li className="flex items-start gap-2">
                    <Check className="w-5 h-5 text-white flex-shrink-0" />
                    <span>All Student features</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <Check className="w-5 h-5 text-white flex-shrink-0" />
                    <span>Priority event access</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <Check className="w-5 h-5 text-white flex-shrink-0" />
                    <span>Social media boosts</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <Check className="w-5 h-5 text-white flex-shrink-0" />
                    <span>Member directory access</span>
                  </li>
                </ul>
                <a href="/auth" className="block w-full bg-white text-center py-3 rounded-lg font-semibold hover:bg-gray-100 transition-colors no-underline" style={{color: '#1A1A1A'}}>
                  Get Started
                </a>
              </div>

              {/* Enterprise */}
              <div className="dashboard-card">
                <div className="text-center mb-6">
                  <h3 className="text-2xl font-bold mb-2" style={{fontFamily: 'var(--font-heading)'}}>Enterprise/Team</h3>
                  <div className="text-4xl font-bold mb-2" style={{color: 'var(--gold)'}}>Custom</div>
                  <p style={{color: 'var(--muted)'}}>contact us</p>
                </div>
                <ul className="space-y-3 mb-8">
                  <li className="flex items-start gap-2">
                    <Check className="w-5 h-5 flex-shrink-0" style={{color: '#10b981'}} />
                    <span>All General features</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <Check className="w-5 h-5 flex-shrink-0" style={{color: '#10b981'}} />
                    <span>Bulk team pricing</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <Check className="w-5 h-5 flex-shrink-0" style={{color: '#10b981'}} />
                    <span>Dedicated account manager</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <Check className="w-5 h-5 flex-shrink-0" style={{color: '#10b981'}} />
                    <span>Custom integrations</span>
                  </li>
                </ul>
                <a href="mailto:info@oursuccessclub.com" className="btn-primary block text-center no-underline">
                  Contact Us
                </a>
              </div>
            </div>
          </div>

          {/* Host Pricing */}
          <div className="mb-16">
            <h2 className="text-center">Host Pricing</h2>
            <div className="max-w-4xl mx-auto mt-8">
              <div className="dashboard-card">
                <div className="grid md:grid-cols-2 gap-8">
                  <div>
                    <h3 style={{fontFamily: 'var(--font-heading)', fontSize: '1.75rem'}}>Host Membership</h3>
                    <div className="text-4xl font-bold mb-4" style={{color: '#10b981'}}>FREE</div>
                    <p className="mb-6" style={{color: 'var(--muted)'}}>Build and manage your own Success Club community</p>
                    <ul className="space-y-3">
                      <li className="flex items-start gap-2">
                        <Check className="w-5 h-5 flex-shrink-0" style={{color: '#10b981'}} />
                        <span>Host your own events</span>
                      </li>
                      <li className="flex items-start gap-2">
                        <Check className="w-5 h-5 flex-shrink-0" style={{color: '#10b981'}} />
                        <span>Create challenges for members</span>
                      </li>
                      <li className="flex items-start gap-2">
                        <Check className="w-5 h-5 flex-shrink-0" style={{color: '#10b981'}} />
                        <span>Revenue share program</span>
                      </li>
                      <li className="flex items-start gap-2">
                        <Check className="w-5 h-5 flex-shrink-0" style={{color: '#10b981'}} />
                        <span>Member management tools</span>
                      </li>
                    </ul>
                  </div>
                  <div>
                    <h3 style={{fontFamily: 'var(--font-heading)', fontSize: '1.75rem'}}>Optional CRM Functions</h3>
                    <div className="text-3xl font-bold mb-4" style={{color: 'var(--gold)'}}>Custom Pricing</div>
                    <p className="mb-6" style={{color: 'var(--muted)'}}>Advanced CRM capabilities tailored to your needs</p>
                    <ul className="space-y-3 mb-6">
                      <li className="flex items-start gap-2">
                        <Check className="w-5 h-5 flex-shrink-0" style={{color: 'var(--gold)'}} />
                        <span>Advanced analytics</span>
                      </li>
                      <li className="flex items-start gap-2">
                        <Check className="w-5 h-5 flex-shrink-0" style={{color: 'var(--gold)'}} />
                        <span>Automated workflows</span>
                      </li>
                      <li className="flex items-start gap-2">
                        <Check className="w-5 h-5 flex-shrink-0" style={{color: 'var(--gold)'}} />
                        <span>Email campaigns</span>
                      </li>
                      <li className="flex items-start gap-2">
                        <Check className="w-5 h-5 flex-shrink-0" style={{color: 'var(--gold)'}} />
                        <span>Custom integrations</span>
                      </li>
                    </ul>
                    <a href="mailto:info@oursuccessclub.com" className="inline-flex items-center gap-2 font-semibold" style={{color: 'var(--gold)'}}>
                      <Mail className="w-5 h-5" />
                      info@oursuccessclub.com
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Event Host Pricing */}
          <div className="mb-16">
            <h2 className="text-center">Event Host Access</h2>
            <div className="max-w-3xl mx-auto mt-8">
              <div className="dashboard-card" style={{background: 'linear-gradient(135deg, #1a1a1a 0%, #0a0a0a 100%)', color: '#fff', border: '2px solid #D4AF37'}}>
                <div className="text-center mb-6">
                  <h3 className="text-2xl font-bold mb-4" style={{fontFamily: 'var(--font-heading)', color: '#D4AF37'}}>Single Event Access</h3>
                  <p className="mb-6" style={{color: 'rgba(255,255,255,0.9)'}}>
                    Purchase Success Club access for all attendees at your event
                  </p>
                  <div className="text-3xl font-bold mb-6" style={{color: '#D4AF37'}}>Custom Pricing</div>
                </div>
                <div className="grid md:grid-cols-2 gap-6 mb-8">
                  <div style={{background: 'rgba(212, 175, 55, 0.1)', borderRadius: '12px', padding: '1.5rem', border: '1px solid rgba(212, 175, 55, 0.2)'}}>
                    <h4 className="font-semibold mb-3" style={{color: '#D4AF37'}}>Perfect For:</h4>
                    <ul className="text-sm space-y-2" style={{color: 'rgba(255,255,255,0.9)'}}>
                      <li>• Conferences</li>
                      <li>• Corporate events</li>
                      <li>• Workshops & seminars</li>
                      <li>• Networking events</li>
                    </ul>
                  </div>
                  <div style={{background: 'rgba(212, 175, 55, 0.1)', borderRadius: '12px', padding: '1.5rem', border: '1px solid rgba(212, 175, 55, 0.2)'}}>
                    <h4 className="font-semibold mb-3" style={{color: '#D4AF37'}}>Includes:</h4>
                    <ul className="text-sm space-y-2" style={{color: 'rgba(255,255,255,0.9)'}}>
                      <li>• Event duration access</li>
                      <li>• Full platform features</li>
                      <li>• Attendee networking</li>
                      <li>• Post-event analytics</li>
                    </ul>
                  </div>
                </div>
                <div className="text-center">
                  <a href="mailto:info@oursuccessclub.com" className="inline-flex items-center gap-2 px-6 py-3 rounded-lg font-semibold transition-colors no-underline" style={{background: '#D4AF37', color: '#000'}}>
                    <Mail className="w-5 h-5" />
                    Contact for Event Pricing
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </PublicLayout>
  );
};

export default Pricing;